/* eslint-disable import/prefer-default-export */
// calculated values (aligned/interpolated) will not work because of recent changes to dynamic System Of Units
export const FORCE_DISABLE_SCAN_DEPOL_ALIGNMENT_AND_INTERPOLATION = true; 